// src/views/kiddo-games/recognize/WordFromList.tsx
// Kopia src/components/Recognize/WordFromList.tsx — tylko dla Rozpoznaj słowo Easy
import React, { FC } from 'react';
import { FitText } from '../../../components/FitText/FitText';
import classes from './WordFromList.module.less';

type CardProps = {
  id: any,
  content: string,
};

export const WordFromList: FC<CardProps> = ({
  content, id,
}) => (
  <>
    {/* Długi zwrot dostaje mniejszą czcionkę, żeby zmieścił się w karcie (na telefonie) */}
    <FitText
      className={classes.word}
      id={id}
    >
      {content}
    </FitText>
  </>
);

export default WordFromList;
